// extracted by mini-css-extract-plugin
export default {"wrapper":"Related_wrapper__3pA+u","results":"Related_results__55Mrw","closeButton":"Related_closeButton__lJuHs"};